import {
  AscendingOrder,
  DefaultSort,
  DescendingOrder,
  Sort,
  SortDelegate,
  TableCustomSort,
} from '@purespectrum1/ui/table';
import { TableColumnSortOption } from '@purespectrum1/ui/table/domain/types';
import {
  Reconciliation,
  SurveyListing,
} from '../../../shared/services/buyer-api/survey.interface';
import { Constants } from '../../dashboard-constants';

type ValueOfSurveyListing = SurveyListing[keyof SurveyListing];

class ReconciledSort extends TableCustomSort<Reconciliation> {
  public order(
    reconciliationA: Reconciliation,
    reconciliationB: Reconciliation
  ): number {
    const totalReconA = this._totalReconciliation(reconciliationA);
    const totalReconB = this._totalReconciliation(reconciliationB);

    if (totalReconA > totalReconB) {
      return this._order.after();
    }

    if (totalReconA < totalReconB) {
      return this._order.before();
    }

    return this._order.equal();
  }

  private _totalReconciliation(reconciliation: Reconciliation) {
    return reconciliation
      ? reconciliation.accept + reconciliation.reject + reconciliation.complete
      : 0;
  }
}

export class SurveyTableSortDelegate
  implements SortDelegate<ValueOfSurveyListing>
{
  public sort(
    field: string,
    type: TableColumnSortOption
  ): Sort<ValueOfSurveyListing> {
    const order = this._order(type);
    const enabled = type !== 'none';

    if (!enabled) {
      return DefaultSort.from('none');
    }

    if (field === Constants.RECONCILIATION.KEY) {
      return new ReconciledSort(order, enabled);
    }

    return DefaultSort.from(type);
  }

  private _order(type: TableColumnSortOption) {
    return type === 'ascending' ? new AscendingOrder() : new DescendingOrder();
  }
}
